import HeaderMenu from "./header-menu/HeaderMenu";
import {ReactNode} from "react";
import {Box} from "@mui/material";

export const Page = ({children}: { children: ReactNode }) => {
    return <><HeaderMenu /><Box padding={3}>{children}</Box></>
}
